import { isEmpty } from 'ramda';
import pushMessages from 'js/hooks/socket/pushMessages';

import { COLORS } from './constants';

export const formatMessage = (options) => {
    const {
        message,
        accent = '',
        title = 'Title',
        color = COLORS.default,
        description = 'Description'
    } = options;
    const style = `color: ${color}`;
    const accentStyle = `${style}; font-style:italic`;
    const time = message.time ? `${message.time}ms` : new Date().toLocaleTimeString();

    if (accent) {
        return [`%c[${title}] %c${accent} %c| ${description} | ${time} | %O`, style, accentStyle, style, message];
    }

    return [`%c[${title}] ${description} | ${time} | %O`, `color: ${color}`, message];
};

export const parseOpenApiMessage = (message, { color, title, type }) => {
    let ID;
    let description;
    let reason = '';

    if (type === 'oapiError') {
        ({ reason = 'Unknown error' } = message);
        ({ ID } = message.response || message.request);
        ({ description } = message.request);
    } else {
        ({ ID, description } = message);
    }

    ID = ID ?? '';
    description = description ?? pushMessages[ID] ?? 'description not found';

    const msgTitle = title || type;
    const msgColor = type === 'oapiPush' && !pushMessages[ID] ? COLORS.unknownPush : color;

    return formatMessage({ description, accent: reason, message, title: `${msgTitle} ${ID}`, color: msgColor });
};

export const parseRedirectMessage = (message, { color, title, type }) => {
    const { error, redirectType } = message;
    const description = type === 'redirectRequest' ? redirectType || '' : error ? 'error' : 'success';

    return formatMessage({
        description,
        message,
        title,
        color
    });
};

export const parseAzureMessage = (message, options) => {
    const { name: description } = message;

    return formatMessage({
        description,
        message,
        ...options
    });
};

export const parseHTTPMessage = (message, { color, title }) => {
    const { url, method = 'get', time } = message;

    return formatMessage({
        description: method.toUpperCase(),
        title: `${title} ${url}`,
        color,
        message,
        time
    });
};

export const parseGCMessage = (message, { color, title }) => {
    const { transactionID, event = 'geoPacket', time } = message;

    return formatMessage({
        description: transactionID,
        title: `${title} - ${event}`,
        color,
        message,
        time
    });
};

export const parsePasMessage = (message, { color, title }) => {
    const { actionName } = message;
    const {
        description = actionName
            .split('iapi')[1]
            .match(/[A-Z][a-z]+/g)
            .join(' ')
            .toLowerCase()
    } = message;

    return formatMessage({
        description,
        title: `${title} ${actionName}`,
        color,
        message
    });
};

export const parseNestingMessage = (message, options) => {
    return formatMessage({
        message: '',
        description: message,
        ...options
    });
};

export const parseReduxMessage = (message, options) => {
    const { description } = message;

    delete message.description;

    return formatMessage({
        message: isEmpty(message) ? '' : message,
        description,
        ...options
    });
};
